import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SharedState } from './shared.state';

export const sharedFeatureKey = 'shared';

export const selectShared = createFeatureSelector<SharedState>(sharedFeatureKey);

export const selectCurrentHitId = createSelector(selectShared, state => state.currentHitId);
